import { defineMessages } from 'react-intl';

export default defineMessages({
  caption: 'TRIBE token rewards',
  descriptionFirst:
    'The Fei Protocol governance has decided to give {tribe} rewards to variable borrowing of {fei} on Aave in {link}',
  thisProposal: 'this proposal',
  descriptionSecond:
    'For more information about the rewards and how to claim them, visit the {link}',
  feiProtocolApp: 'Fei Protocol App',
  descriptionThird:
    'This is offered strictly by the Fei Protocol and the Aave Protocol does not have any involvement in the TRIBE rewards. The Fei Protocol App is a third party application affiliated with Fei and not with Aave in any way.',
});
